import type { MRT_ColumnDef } from "mantine-react-table-open";
import { Link } from "react-router";
import { StackOrModal } from "../../../../mantine/components/StackOrModal/StackOrModal";
import type { Person } from "../../../../utils/backend-types";

function getSitesWhereActive(companies: Array<Person>): MRT_ColumnDef<Person> {
  const uniqueSitesWhereActive = Array.from(
    new Set(
      companies.flatMap(
        (company) =>
          company.sitesWhereActive?.map(
            (site) => `${site.name} (${site.id})`
          ) || []
      )
    )
  );

  return {
    header: "Liegenschaften",
    accessorKey: "sitesWhereActive",
    accessorFn: (row) =>
      row.sitesWhereActive
        ?.map((site) => `${site.name} (${site.id})`)
        .join(","),
    size: 250,
    filterVariant: "multi-select",
    mantineFilterMultiSelectProps: {
      data: uniqueSitesWhereActive
    },
    filterFn: (row, _columnId, filterValue) => {
      if (filterValue.length === 0) {
        return true;
      }
      const companySites =
        row.original.sitesWhereActive?.map(
          (site) => `${site.name} (${site.id})`
        ) || [];
      return filterValue.some((filterSite) =>
        companySites.includes(filterSite)
      );
    },
    Cell: ({ row }) => (
      <StackOrModal
        elementText="Liegenschaften"
        modalColumns={1}
        numElements={row.original.sitesWhereActive?.length || 0}
      >
        {row.original.sitesWhereActive?.map((site) => (
          <Link key={site.id} to={`../liegenschaften/${site.id}`}>
            {`${site.name} (${site.id})`}
          </Link>
        ))}
      </StackOrModal>
    )
  };
}

export { getSitesWhereActive };
